import React, { useContext, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import { WEBCASTING_PLATFORM_URL } from '../config/config';

import WebcastingContext from '../context/webcasting/webcastingContext';

const HeadStyle = ({ branding }) => {
  const webcastingContext = useContext(WebcastingContext);
  const { event } = webcastingContext;
  // event is empty on first render; it's set asynchronously when getEvent() completes in Live.jsx
  // You'll see a second log with data once the API returns and context updates
  console.log('eventFromHeadStyle', event);

  const [eventId, setEventId] = useState('');
  const [eventTitle, setEventTitle] = useState('');
  const [eventDescription, setEventDescription] = useState('');
  const [fontsFounded, setFontsFounded] = useState(false);
  const [fontDefault, setFontDefault] = useState([]);
  const [fontTitle, setFontTitle] = useState([]);
  const [fontDescription, setFontDescription] = useState([]);
  const [cssFormat, setCssFormat] = useState([]);
  const [woffFormat, setWoffFormat] = useState([]);
  const [weHaveFonts, setWeHaveFonts] = useState(false);
  const [ogImageUrl, setOgImageUrl] = useState('');

  // Pick role value, then default, then hardcoded fallback (treats "" as missing)
  function pickFontProp(roleFont, defaultFont, prop, fallback) {
    const roleValue = roleFont?.[prop];
    if (roleValue !== undefined && roleValue !== null && roleValue !== '') {
      return roleValue;
    }
    const defaultValue = defaultFont?.[prop];
    if (defaultValue !== undefined && defaultValue !== null && defaultValue !== '') {
      return defaultValue;
    }
    return fallback;
  }

  // CSS requires quotes around font-family names that contain spaces
  function quoteFontFamily(family) {
    if (!family) return 'sans-serif';
    const trimmed = String(family).trim();
    if (
      /^(serif|sans-serif|monospace|cursive|fantasy|system-ui)$/i.test(trimmed) ||
      (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
      (trimmed.startsWith("'") && trimmed.endsWith("'"))
    ) {
      return trimmed;
    }
    if (/\s/.test(trimmed)) {
      return `"${trimmed.replace(/"/g, '')}"`;
    }
    return trimmed;
  }

  function mapFontEntry(font) {
    if (!font) return null;
    // Support both new (fontStyleLink/baseSize/color/format) and old field names
    return {
      fontLinkHref: font.fontStyleLink || font.fontLinkHref || '',
      fontFormat: font.format || font.fontFormat || '',
      fontFamily: font.fontFamily || '',
      fontSizeBase: font.baseSize || font.fontSizeBase || '',
      fontColor: font.color || font.fontColor || '',
      fontWeight: font.fontWeight || '',
    };
  }

  // Helper function to normalize font structure (handles both old array and new object)
  function normalizeFonts(fonts) {
    if (!fonts) return { default: null, title: null, description: null, allFonts: [] };
    
    // New structure: object with keys (default, title, description)
    if (fonts && typeof fonts === 'object' && !Array.isArray(fonts)) {
      const normalized = {
        default: mapFontEntry(fonts.default),
        title: mapFontEntry(fonts.title),
        description: mapFontEntry(fonts.description),
        allFonts: []
      };
      
      // Only collect entries that have a real font URL to load
      [normalized.default, normalized.title, normalized.description]
        .filter((f) => f?.fontLinkHref)
        .forEach((f) => normalized.allFonts.push(f));
      
      return normalized;
    }
    
    // Old structure: array of objects
    if (Array.isArray(fonts)) {
      const defaultFont = filterFont(fonts, 'fontPosition', 'default')[0] || null;
      const titleFont = filterFont(fonts, 'fontPosition', 'title')[0] || null;
      const descriptionFont = filterFont(fonts, 'fontPosition', 'description')[0] || null;
      return {
        default: mapFontEntry(defaultFont),
        title: mapFontEntry(titleFont),
        description: mapFontEntry(descriptionFont),
        allFonts: fonts.filter((f) => f?.fontLinkHref || f?.fontStyleLink),
      };
    }
    
    return { default: null, title: null, description: null, allFonts: [] };
  }

  function filterFont(arr, key, value) {
    return arr.filter((e) => e[key] === value);
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (event) {
        const eventData = event;

        setEventId(eventData._id);  
        eventData.title && setEventTitle(eventData.title);
        eventData.description && setEventDescription(eventData.description);

        const fonts = eventData?.webcast?.branding?.fonts;
        if (fonts && ((Array.isArray(fonts) && fonts.length > 0) || (typeof fonts === 'object' && !Array.isArray(fonts)))) {
          setFontsFounded(true);
          const normalized = normalizeFonts(fonts);
          
          console.log('All woff format', normalized.allFonts);

          setFontDefault(normalized.default ? [normalized.default] : []);
          setFontTitle(normalized.title ? [normalized.title] : []);
          setFontDescription(normalized.description ? [normalized.description] : []);

          setCssFormat(filterFont(normalized.allFonts, 'fontFormat', 'css'));
          setWoffFormat([
            ...filterFont(normalized.allFonts, 'fontFormat', 'woff'),
            ...filterFont(normalized.allFonts, 'fontFormat', 'woff2'),
          ]);

        }

        if (eventData?.players?.cover) {
          setOgImageUrl(eventData?.players?.cover);
        }
      }
    }

    return () => {
      mounted = false;
    };
  }, [event]);



  //console log all fonts
  useEffect(() => {
    console.log('checking fontDefault', fontDefault);
    console.log('checking fontTitle', fontTitle);
    console.log('fontDescription', fontDescription);
  }, [fontDefault, fontTitle, fontDescription]);


  useEffect(() => {
    // if (fontTitle.length > 0) setWeHaveFonts(true);
    // if (fontDefault.length > 0) {
    //   if (fontDefault[0].fontLinkHref !== '') {
    //     setWeHaveFonts(true);
    //   }
    // }
    // if (fontTitle.length > 0) {
    //   if (fontTitle[0].fontLinkHref !== '') {
    //     setWeHaveFonts(true);
    //   }
    // }
    // if (fontDescription.length > 0) {
    //   if (fontDescription[0].fontLinkHref !== '') {
    //     setWeHaveFonts(true);
    //   }
    // }
    setWeHaveFonts(true);
  }, [branding]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{eventTitle}</title>
        <meta property='og:title' content={eventTitle} />
        <meta property='og:description' content={eventDescription} />
        <meta property='og:type' content='website' />
        <meta property='og:image' content={ogImageUrl} />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_WEBCASTING_PLATFORM_URL}/broadcast/${eventId}`}
        />
        <meta name='twitter:title' content={eventTitle} />
        <meta name='twitter:description' content={eventDescription} />
        <meta name='twitter:image' content={ogImageUrl} />
        <meta
          name='twitter:url'
          content={`${process.env.REACT_APP_WEBCASTING_PLATFORM_URL}/broadcast/${eventId}`}
        />
        {fontsFounded && (
          <>
            {cssFormat.length > 0 &&
              cssFormat.map((e, idx) => (
                <link
                  key={idx}
                  href={`${e.fontLinkHref}`}
                  rel='stylesheet'
                ></link>
              ))}

            {woffFormat.length > 0 &&
              woffFormat.map((e, idx) => (
                <link
                  crossorigin='anonymous'
                  key={idx}
                  as='font'
                  href={`${e.fontLinkHref}`}
                  rel='preload'
                  // rel='stylesheet preload'
                  type='font/woff'
                />
              ))}
            {woffFormat.length > 0 &&
              woffFormat.map((e, idx) => (
              
                <style key={idx}>
                  {`
                  @font-face {
                    src: url(${e.fontLinkHref}) format(${e.fontFormat});
                    font-family: ${quoteFontFamily(e.fontFamily)};
                  }
                  `}
                </style>
              ))}

            {weHaveFonts && (
              <style type='text/css'>{`
            .title {
              font-family: ${quoteFontFamily(
                pickFontProp(fontTitle[0], fontDefault[0], 'fontFamily', 'sans-serif')
              )}, sans-serif;
              font-size: ${pickFontProp(fontTitle[0], fontDefault[0], 'fontSizeBase', '1rem')};
              font-weight: ${pickFontProp(fontTitle[0], fontDefault[0], 'fontWeight', 'normal')};
              color: ${pickFontProp(fontTitle[0], fontDefault[0], 'fontColor', '#000000')};
            }
            .description{
              font-family: ${quoteFontFamily(
                pickFontProp(fontDescription[0], fontDefault[0], 'fontFamily', 'sans-serif')
              )}, sans-serif;
              font-size: ${pickFontProp(fontDescription[0], fontDefault[0], 'fontSizeBase', '1rem')};
              font-weight: ${pickFontProp(fontDescription[0], fontDefault[0], 'fontWeight', 'normal')};
              color: ${pickFontProp(fontDescription[0], fontDefault[0], 'fontColor', '#000000')};
            }
            `}</style>
            )}
          </>
        )}
      </Helmet>
    </HelmetProvider>
  );
};

export default HeadStyle;
